import { render, staticRenderFns } from "./GlobalFooterForSimple.vue?vue&type=template&id=11a2f1ce&scoped=true&lang=pug&"
import script from "./GlobalFooterForSimple.vue?vue&type=script&lang=ts&"
export * from "./GlobalFooterForSimple.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalFooterForSimple.vue?vue&type=style&index=0&id=11a2f1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a2f1ce",
  null
  
)

export default component.exports